import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Payments from '../../Common/Payment';

class Payment extends Component {

  render() {
    const { client, yate } = this.props;

    const quoterData = {
      BeneficiaryCode: "0", // valor fijo por documento de servicios
      DocumentNumber: client.documentNumber, // TODO: VALIDAR QUE SEA LA CÉDULA
      ResidenceZoneCode: yate.zonaResidencia.value,
      MarineCode: yate.marina.value,
      ExtinguishersCount: yate.extintores,
      Plate: yate.matricula,
      Engine: yate.motorNumero,
      ExtinguishersExpirationDate: yate.extFechaExpiracion,
      Observations: yate.observaciones,
    };

    return (
      <div>
        <Payments
          currency='USD'
          quoterData={quoterData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    client: state.client,
    yate: state.yates,
  };
};

export default connect(mapStateToProps, null)(Payment);